<template>
  <b-card no-body class="flex-container">
    <div slot="header">
      <window-header :cmp-title="'Filters for '+(layerConf.title || layerConf.name)" :widget-name="layerConf.id+'filters'"></window-header>
    </div>
    <div class="p-2 " :style="{'flex': 3, 'overflow': 'auto'}">
      <div v-for="fc in filterConf" :key="fc['name']+'filter'" class="mt-1">

        <b-form-input v-if="fc['type'] === 'text'" v-model="q"
                      type="text"
                      :placeholder="fc['name']">
        </b-form-input>

        <!-- TODO: config should hold flag to check if autocomplete necessary -->
        <div class="select-item-options" v-if="fc['type'] === 'text'">
          <b-list-group class='filter-list-group'>
            <b-list-group-item v-for="(option, i) in filterOptions" :key="i"
                               @click.prevent="selectItem(option, fc['name'])">{{option}}
            </b-list-group-item>
            <template v-if="!filterOptions.length && showNotFound">
              <li class="list-group-item bg-light"><span class="not-found-label">{{notFoundText}}</span></li>
            </template>
          </b-list-group>
        </div>

        <b-form-select v-if="fc['type'] === 'list'" v-model="values[fc['name']]" :options="fc['values'].map(function(v){
            return {
              value: v,
              text: v
            }
            })"/>
      </div>
    </div>

    <div slot="footer">
      <div class="d-flex">
        <b-button size="sm" class="layer-filter-button" @click.stop.prevent="clearFilters">Clear</b-button>
        <b-button size="sm" class="layer-filter-button" variant="primary" @click.stop.prevent="applyFilters">Apply</b-button>
      </div>
    </div>
  </b-card>
</template>

<script>

  import WindowHeader from '../../common/WindowHeader'

  export default {
    name: 'LayerFilters',
    components: {WindowHeader},
    props: {
      'filterConf': {
        default: () => []
      },
      'label': {
        default: 'Filters'
      },
      'layerKegsId': {
        default: null
      }
    },
    created () {
      this.getLayer()
    },
    data () {
      return {
        filterOptions: [],
        values: {},
        confMap: {},
        showNotFound: false,
        skipUpdate: false,
        layerConf: null,
        q: ''
      }
    },
    computed: {
      contentHeight () {
        return 2.5 * (this.filterConf.length + 1)
      }
    },
    mounted () {
      this.filterConf.forEach(fc => {
        if (fc['type'] === 'computed') {
          this.values[fc['name']] = this.getComputedValue(fc)
        }
        this.confMap[fc['name']] = fc
      })

    },
    watch: {
      q (val) {
        if (val && !this.skipUpdate) {
          this.requestFieldComplete(val)
        } else {
          this.filterOptions = []
          this.skipUpdate = false
        }
      }
    },
    methods: {
      selectItem (val, fc) {
        this.skipUpdate = true
        this.q = val
        this.filterOptions = []
        this.values[fc] = val
      },
      requestFieldComplete (val) {
        this.$http.get('/api/layers/get-route-filter', {
          params: {
            route: val
          }
        })
          .then(res => {
            let op = res.body
            if (op.length) {
              this.filterOptions = op.map(r => {
                return r.well_ident
              })
            } else {
              this.filterOptions = []
            }
          }, r => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get Well Ident',
              type: 'error'
            })
          })
      },
      applyFilters () {
        let cql_custom = []
        console.log(this.values)
        for (let k in this.values) {
          if (this.values.hasOwnProperty(k)) {
            let value = this.values[k]
            let conf = this.confMap[k]
            if (conf['data_type'] === 'text') {
              value = `'${value}'`
            }
            cql_custom.push([k, value].join('='))
          }
        }

        let layer = this.getLayer()
        if (!layer) {
          this.$notify({
            title: 'Something went wrong',
            text: 'Could not find layer config',
            type: 'error'
          })
          return
        }
        layer['cql_custom'] = cql_custom.join(' and ')
        this.$mapService.forceCreateLayer(layer)
        this.$store.commit('map/setLayerFilter', [this.layerConf['id'], true])
      },
      clearFilters () {
        this.q = ''
        for (let k in this.values) {
          if (this.values.hasOwnProperty(k)) {
            this.values[k] = null
          }
        }

        let layer = this.getLayer()
        layer['cql_custom'] = null
        this.$mapService.forceCreateLayer(layer)
        this.$store.commit('map/setLayerFilter', [this.layerConf['id'], false])
      },
      getLayer () {
        if (this.layerConf) {
          return this.layerConf
        }
        let layers = []
        this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
          if (node['id'] === this.layerKegsId) {
            layers.push(node)
          }
        })

        this.layerConf = layers[0]
        return this.layerConf
      },
      getComputedValue (fc) {
        if (fc['name'] === 'workpack_id') {
          return this.$store.getters['project/currentProject']
        }

        return undefined
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/layers/LayerFilters.vue